var React = require('react');

function MoePen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M57.777 21.722l-9.732-9.895 4.03-4.031 9.814 9.815-4.112 4.11zm-32.4 32.4l-9.814-9.814 28.946-28.945 9.732 9.894-28.864 28.865zM7.147 61.74l4.43-11.957 8.27 8.12-12.7 3.837zm1.345-17.432l.048.049-.31.068L.71 64.718l3.068 3.262 21.556-6.51.077-.31L68.96 17.61 52.075.727 8.492 44.308z","fill":"#FFF","fillRule":"evenodd"}));
}

MoePen.defaultProps = {"width":"69","height":"68"};

module.exports = MoePen;

MoePen.default = MoePen;
